import { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import logo from "../Images/footerlogo.svg";
import F2 from "../Images/insta.png";
import F3 from "../Images/facebook.png";
import F4 from "../Images/youtube.png";
import F5 from "../Images/gmb.svg";
import { Link, useNavigate } from "react-router-dom";
import { Col, Row } from "react-bootstrap";
import { FaPhoneAlt } from "react-icons/fa";
import { IoLogoWhatsapp } from "react-icons/io";
import "./Footer.css";

const Footer = () => {
  const navigate = useNavigate();

  const handleInternalNavigation = (event) => {
    const link = event.target.closest("a");
    const href = link?.getAttribute("href");

    if (!href?.startsWith("/") || link.target === "_blank") return;

    event.preventDefault();
    navigate(href);
  };

  useEffect(() => {
    import("bootstrap/dist/js/bootstrap.bundle.min.js");
  }, []);

  return (
    <>
      <footer
        onClick={handleInternalNavigation}
        className="footer p-0 "
        style={{
          background:
            "linear-gradient(to right, rgb(175, 221, 255), rgb(255, 255, 255))",
          overflow: "hidden",
        }}
      >
        <Row className="justify-content-center mt-md-5 mt-2 mb-md-5 mb-2 mx-0">
          <Col xs={12} md={10} className="px-3 px-sm-4">
            <div className="py-4">
              <div className="row gy-4">
                <div className="col-12 col-lg-9">
                  <div className="row row-cols-1 row-cols-sm-2 row-cols-lg-3 g-4">
                    <div className="col">
                      <p className="h6" style={{ marginBottom: "6px" }}>
                        <strong>Competitive Research</strong>
                      </p>

                      <div
                        style={{
                          width: "80px",
                          height: "5px",
                          background:
                            "linear-gradient(90deg, #4F46E5, #06B6D4)",
                          borderRadius: "50px",
                          marginBottom: "15px",
                        }}
                      ></div>
                      <div className="mb-1">
                        <a
                          href="/da-pa-checker"
                          className="text-decoration-none text-dark"
                        >
                          Domain Overview
                        </a>
                      </div>
                      <div className="mb-1">
                        <a
                          href="/serp-simulator"
                          className="text-decoration-none text-dark"
                        >
                          SERP Simulator
                        </a>
                      </div>
                      <div className="mb-1">
                        <a
                          href="/keyword-gap"
                          className="text-decoration-none text-dark"
                        >
                          Keyword Gap
                        </a>
                      </div>
                      <hr />
                      <p className="h6">
                        <strong>Keyword Research</strong>
                      </p>
                      <div
                        style={{
                          width: "80px",
                          height: "5px",
                          background:
                            "linear-gradient(90deg, #4F46E5, #06B6D4)",
                          borderRadius: "50px",
                          marginBottom: "15px",
                        }}
                      ></div>
                      <div className="mb-1">
                        <a
                          href="/best-keyword-research-tool"
                          className="text-decoration-none text-dark"
                        >
                          Bix keyword Research
                        </a>
                      </div>
                      <div className="mb-1">
                        <a
                          href="/bix-keyword-analyzer"
                          className="text-decoration-none text-dark"
                        >
                          Domain Ranking Keyword
                        </a>
                      </div>
                      <div className="mb-1">
                        <a
                          href="/construct-your-seo-success-with-keyword-builder"
                          className="text-decoration-none text-dark"
                        >
                          Keyword Builder
                        </a>
                      </div>
                      <hr />
                      <p className="h6">
                        <strong>Bix Labs with Google</strong>
                      </p>
                      <div
                        style={{
                          width: "80px",
                          height: "5px",
                          background:
                            "linear-gradient(90deg, #4F46E5, #06B6D4)",
                          borderRadius: "50px",
                          marginBottom: "15px",
                        }}
                      ></div>
                      <div className="mb-1">
                        <a
                          href="/google-analytics"
                          className="text-decoration-none text-dark"
                        >
                          Google Analytics
                        </a>
                      </div>
                      <div className="mb-1">
                        <a
                          href="/search-console"
                          className="text-decoration-none text-dark"
                        >
                          Google Search Console
                        </a>
                      </div>
                      <div className="mb-1">
                        <a
                          href="/trending-now-on-google"
                          className="text-decoration-none text-dark"
                        >
                          Google Trends
                        </a>
                      </div>
                    </div>
                    <div className="col">
                      <p className="h6" style={{ marginBottom: "6px" }}>
                        <strong>Social Media Strategy</strong>
                      </p>
                      <div
                        style={{
                          width: "80px",
                          height: "5px",
                          background:
                            "linear-gradient(90deg, #4F46E5, #06B6D4)",
                          borderRadius: "50px",
                          marginBottom: "15px",
                        }}
                      ></div>
                      <div className="mb-1">
                        <a
                          href="/youtube-insight-analyzer"
                          className="text-decoration-none text-dark"
                        >
                          YouTube Insight Analyzer
                        </a>
                      </div>
                      <div className="mb-1">
                        <a
                          href="/instagram-profile-analyzer"
                          className="text-decoration-none text-dark"
                        >
                          Instagram Profile Analyzer
                        </a>
                      </div>
                      <div className="mb-1">
                        <a
                          href="/facebook-profile-page-analyzer"
                          className="text-decoration-none text-dark"
                        >
                          Facebook Profile & Page Analyzer
                        </a>
                      </div>

                      <hr />

                      <p className="h6">
                        <strong>Content Creation</strong>
                      </p>
                      <div
                        style={{
                          width: "80px",
                          height: "5px",
                          background:
                            "linear-gradient(90deg, #4F46E5, #06B6D4)",
                          borderRadius: "50px",
                          marginBottom: "15px",
                        }}
                      ></div>
                      <div className="mb-1">
                        <a
                          href="/facebook-post-content-creator"
                          className="text-decoration-none text-dark"
                        >
                          Facebook Post & Content Creator
                        </a>
                      </div>
                      <div className="mb-1">
                        <a
                          href="/instagram-post-reel-creator"
                          className="text-decoration-none text-dark"
                        >
                          Instagram Post & Reel Creator
                        </a>
                      </div>
                      <div className="mb-1">
                        <a
                          href="/youtube-content-planner"
                          className="text-decoration-none text-dark"
                        >
                          YouTube Content Planner
                        </a>
                      </div>

                      <hr />

                      <p className="h6">
                        <strong>Social Media Analytics</strong>
                      </p>
                      <div
                        style={{
                          width: "80px",
                          height: "5px",
                          background:
                            "linear-gradient(90deg, #4F46E5, #06B6D4)",
                          borderRadius: "50px",
                          marginBottom: "15px",
                        }}
                      ></div>
                      <div className="mb-1">
                        <a
                          href="/instagram-hashtag-generator"
                          className="text-decoration-none text-dark"
                        >
                          Instagram Hashtag Generator
                        </a>
                      </div>
                      <div className="mb-1">
                        <a
                          href="/facebook-hashtag-finder"
                          className="text-decoration-none text-dark"
                        >
                          Facebook Hashtag Finder
                        </a>
                      </div>
                      <div className="mb-1">
                        <a
                          href="/instagram-post-scheduler"
                          className="text-decoration-none text-dark"
                        >
                          Instagram Post Scheduler
                        </a>
                      </div>
                    </div>
                    <div className="col">
                      <p className="h6" style={{ marginBottom: "6px" }}>
                        <strong>Digital Marketing Services</strong>
                      </p>

                      <div
                        style={{
                          width: "80px",
                          height: "5px",
                          background:
                            "linear-gradient(90deg, #4F46E5, #06B6D4)",
                          borderRadius: "50px",
                          marginBottom: "15px",
                        }}
                      ></div>
                      <div className="mb-3" style={{fontSize:".9rem"}}>
                        <a
                          href="/digital-marketing-company-noida"
                          className="text-decoration-none text-dark"
                        >
                          Digital Marketing Company Noida
                        </a>
                      </div>
                      <div className="mb-3" style={{fontSize:".9rem"}}>
                        <a
                          href="/seo-company-noida"
                          className="text-decoration-none text-dark"
                        >
                          SEO Company Noida
                        </a>
                      </div>
                      

                      <div className="mb-3" style={{fontSize:".8rem"}}>
                        <a
                          href="/social-media-marketing-company-noida"
                          className="text-decoration-none text-dark"
                        >
                          Social Media Marketing Company Noida
                        </a>
                      </div>
                      <div className="mb-3" style={{fontSize:".9rem"}}>
                        <a
                          href="/ppc-company-noida"
                          className="text-decoration-none text-dark"
                        >
                          PPC Company In Noida
                        </a>
                      </div>
                      <div className="mb-3" style={{ fontSize: ".9rem" }}>
                        <Link
                          to="/increase-domain-authority"
                          className="text-decoration-none text-dark"
                        >
                          Increase Your DA With Us
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Right side - Connect With Us */}
                <div className="footer-contact col-12 col-lg-3 ps-lg-4">
                  <h5 className="mb-3">
                    <strong>Connect With Us</strong>
                  </h5>
                  <div className="d-flex flex-wrap gap-2 mb-3">
                    <a
                      href="https://www.instagram.com/seobixofficial/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        style={{ height: "2.6rem" }}
                        src={F2}
                        alt="Facebook"
                       decoding="async" loading="lazy"/>
                    </a>
                    <a
                      href="https://www.facebook.com/seobixofficial/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        style={{ height: "2.6rem" }}
                        src={F3}
                        alt="Instagram"
                       decoding="async" loading="lazy"/>
                    </a>
                    <a
                      href="https://www.youtube.com/@Seobix"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        style={{ height: "2.6rem" }}
                        src={F4}
                        alt="YouTube"
                       decoding="async" loading="lazy"/>
                    </a>
                    <a
                      href="https://share.google/cwogc8QB3FsQa14Gs"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img style={{ height: "2.6rem" }} src={F5} alt="Gmb"  decoding="async" loading="lazy"/>
                    </a>
                  </div>

                  <div className="mb-3">
                    <a
                      href="/contact-us"
                      className="text-decoration-none text-dark d-block"
                    >
                      <strong>Contact the Help team</strong>
                    </a>
                    <address
                      className="mt-2 mb-3"
                      style={{
                        fontStyle: "normal",
                        fontSize: ".9rem",
                        fontWeight: "600",
                      }}
                    >
                      ITHUM Tower, B-212A, Block A, <br />
                      Industrial Area, Sector 62, <br />
                      Noida, Uttar Pradesh – 201301
                    </address>
                    <div className="mb-3">
                      <a
                        href="mailto:support@seobix.com"
                        className="text-decoration-none text-primary me-3"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <strong>support@seobix.com</strong>
                      </a>
                      <br />
                      <strong>+91 7303484700</strong>
                      <br />
                      <div className="d-flex align-items-center mt-3 gap-3">
                        <a
                          href="tel:7303484700"
                          aria-label="Call SeoBix at 7303484700"
                          className="text-decoration-none text-primary d-flex align-items-center gap-2"
                        >
                          <FaPhoneAlt
                            aria-hidden="true"
                            style={{ fontSize: "1.5rem" }}
                          />
                        </a>
                        <a
                          href="tel:7303484700"
                          aria-label="Contact SeoBix on WhatsApp at 7303484700"
                          className="text-decoration-none text-primary d-flex align-items-center gap-2"
                        >
                          <IoLogoWhatsapp
                            aria-hidden="true"
                            style={{ fontSize: "2rem", color: "green" }}
                          />
                        </a>
                      </div>
                    </div>
                  </div>

                  <a href="/register" target="_blank" rel="noreferrer">
                    <button
                      className="btn rounded-pill text-white px-3 py-1"
                      style={{
                        background: "linear-gradient(90deg, #574981, #0075a8)",
                      }}
                    >
                      Sign Up now!
                    </button>
                  </a>
                  <br />
                  <div className="mt-2">
                    <a href="/partners">
                      <button
                        className="btn rounded-pill text-white px-3 py-1"
                        style={{
                          background:
                            "linear-gradient(90deg, #574981, #0075a8)",
                        }}
                      >
                        Be Our Partners
                      </button>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <p className="text-center m-0 p-0"> Managed and Owned By SEOBIX</p>
          </Col>
        </Row>
      </footer>
      <div
        className="py-4"
        style={{ backgroundColor: "#002f50" }}
        onClick={handleInternalNavigation}
      >
        <Row className="justify-content-center mx-0">
          <Col xs={12} md={10} className="px-3 px-sm-4">
            <div className="d-flex flex-column flex-md-row align-items-center justify-content-between gap-3">
              <div className="mb-2 mb-md-0">
                <Link to="/">
                  <img
                    style={{ height: "2rem" }}
                    src={logo}
                    alt="seobix logo"
                   decoding="async"/>
                </Link>
              </div>
              <div className="footer-legal-links d-flex flex-wrap align-items-center justify-content-center justify-content-md-end gap-3 text-white small">
                {/* <p className="mb-0">
                  © 2025 SEOBIX Pvt. Ltd. All rights reserved. SEOBIX is a
                  registered trademark.
                </p> */}
                <a
                  className="text-white text-decoration-none"
                  href="/privacy-policy"
                >
                  Privacy Policy
                </a>
                <a
                  className="text-white text-decoration-none"
                  href="/terms-and-conditions"
                >
                  Terms of Use
                </a>
                <a className="text-white text-decoration-none" href="/faq">
                  FAQ
                </a>
              </div>
            </div>
          </Col>
        </Row>{" "}
      </div>
    </>
  );
};

export default Footer;
